import { Link } from "react-router-dom";

export type Crumb = {
  label: string;
  to?: string;
};

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 overflow-x-auto text-xs text-foreground-600 md:text-sm">
      <Link to="/" className="flex items-center gap-1 whitespace-nowrap hover:text-primary-600">
        <i className="ri-home-4-line"></i>
        首页
      </Link>
      {items.map((item, idx) => {
        const last = idx === items.length - 1;
        return (
          <span key={idx} className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-arrow-right-s-line text-foreground-400"></i>
            {last || !item.to ? (
              <span className={last ? "font-medium text-foreground-900" : "text-foreground-600"} aria-current={last ? "page" : undefined}>
                {item.label}
              </span>
            ) : (
              <Link to={item.to} className="hover:text-primary-600">
                {item.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}